export const weekdays = [
  "Domenica",
  "Lunedì",
  "Martedì",
  "Mercoledì",
  "Giovedì",
  "Venerdì",
  "Sabato"
];

export function slotsToPretty(slots) {
  if (!slots || slots.length == 0) {
    return "Chiuso";
  } else {
    return slots.map(s => `${s.from} - ${s.to}`).join(" | ");
  }
}
